"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var CompaniesActions = _interopRequireWildcard(require("crm_data/companies/CompaniesActions"));

var ContactsActions = _interopRequireWildcard(require("crm_data/contacts/ContactsActions"));

var DealsActions = _interopRequireWildcard(require("crm_data/deals/DealsActions"));

var _immutable = require("immutable");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _LoadingStatus = require("crm_data/constants/LoadingStatus");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _q = _interopRequireDefault(require("q"));

var VisitsActions = _interopRequireWildcard(require("crm_data/visits/VisitsActions"));

var TicketsActions = _interopRequireWildcard(require("crm_data/tickets/TicketsActions"));

var getUpdateObjectPropertiesPromise = function getUpdateObjectPropertiesPromise(objectType, subject, updates, options) {
  switch (objectType) {
    case _ObjectTypes.COMPANY:
      return CompaniesActions.updateCompanyProperties(subject, updates, options);

    case _ObjectTypes.CONTACT:
      return ContactsActions.updateContactProperties(subject, updates, options);

    case _ObjectTypes.DEAL:
      return DealsActions.updateDealProperties(subject, updates, options);

    case _ObjectTypes.TICKET:
      return TicketsActions.updateTicketProperties(subject, updates, options);

    default:
      return _q.default.Promise.reject(new Error("No update action defined for " + objectType));
  }
};

var _default = {
  bulkUpdateStoresLocal: function bulkUpdateStoresLocal(objectType, ids, updates) {
    var propertyMap = updates ? updates.reduce(function (acc, val, key) {
      return acc.setIn(['properties', key, 'value'], val);
    }, (0, _immutable.Map)()) : _LoadingStatus.EMPTY;
    var objectMap = ids.reduce(function (acc, id) {
      return acc.set(id, propertyMap);
    }, (0, _immutable.Map)());

    switch (objectType) {
      case _ObjectTypes.COMPANY:
        return CompaniesActions.updateCompanies(objectMap);

      case _ObjectTypes.CONTACT:
        return ContactsActions.updateContacts(objectMap);

      case _ObjectTypes.DEAL:
        return DealsActions.updateDeals(objectMap);

      case _ObjectTypes.TICKET:
        return TicketsActions.updateTickets(objectMap);

      case _ObjectTypes.VISIT:
        return VisitsActions.updateCompanies(objectMap);

      default:
        throw new Error("`updateStoresLocal` is not defined for objectType `" + objectType + "`");
    }
  },
  updateStores: function updateStores(subject, updates, options) {
    if (options == null) {
      options = {};
    }

    var objectType = (0, _ImmutableModel.getObjectType)(subject);
    return getUpdateObjectPropertiesPromise(objectType, subject, updates, options).then(function () {
      return options.onSuccess && options.onSuccess(updates);
    }).catch(function (error) {
      return options.onError && options.onError(error);
    });
  },
  refresh: function refresh(objectType, subjectId) {
    if (!objectType || !subjectId) {
      return undefined;
    }

    var ids = [subjectId];

    switch (objectType) {
      case _ObjectTypes.COMPANY:
        return CompaniesActions.refresh(ids);

      case _ObjectTypes.CONTACT:
        return ContactsActions.refresh(ids);

      case _ObjectTypes.DEAL:
        return DealsActions.refresh(ids);

      case _ObjectTypes.TICKET:
        return TicketsActions.refresh(ids);

      case _ObjectTypes.VISIT:
        return VisitsActions.refresh(ids);

      default:
        throw new Error("No refresh action defined for " + objectType);
    }
  }
};
exports.default = _default;
module.exports = exports.default;